const mutations = {
  mutationSetInsurerList(state, payload) {
    state.insurerList = payload;
  },
};

export default mutations;
